// Adapted from:
//  - https://git.hubteam.com/HubSpot/conversations-internal-schema/blob/24c061ac8fe4f3aee9b0a5f69a2d760a19563fd5/static/js/routing-rules/builders/buildRoutingRules.ts
//  - https://git.hubteam.com/HubSpot/conversations-internal-schema/blob/24c061ac8fe4f3aee9b0a5f69a2d760a19563fd5/static/js/routing-rules/builders/buildRoutingRulesFromType.ts
import { fromJS } from 'immutable';
import getIn from 'transmute/getIn';
import merge from 'transmute/merge';
import pick from 'transmute/pick';
import set from 'transmute/set';
import { ROUTING_RULE_TYPES } from '../constants/RoutingTypes';
import { DISTRIBUTION, FALLBACK } from '../constants/keyPaths';
import { getType } from '../operators/routingRulesGetters';
import { setDistribution } from '../operators/routingRulesSetters';
import { buildAiChatbotRoutingRules } from '../records/AiChatbotRoutingRules';
import { buildBotRoutingRules } from '../records/BotRoutingRules';
import { buildInboxUsersRoutingRules } from '../records/InboxUsersRoutingRules';
import { buildOwnerRoutingRules } from '../records/OwnerRoutingRules';
import { buildUnassignedRoutingRules } from '../records/UnassignedRoutingRules';
import { buildUsersAndTeamsRoutingRules } from '../records/UsersAndTeamsRoutingRules';
import { getChannelRoutingDistribution } from './distribution';
export function buildRoutingRulesFromType(routingType, options) {
  switch (routingType) {
    case ROUTING_RULE_TYPES.USERS_AND_TEAMS:
      return buildUsersAndTeamsRoutingRules(options);
    case ROUTING_RULE_TYPES.OWNER:
      return buildOwnerRoutingRules(options);
    case ROUTING_RULE_TYPES.INBOX_USERS:
      return buildInboxUsersRoutingRules(options);
    case ROUTING_RULE_TYPES.BOT:
      return buildBotRoutingRules(options);
    case ROUTING_RULE_TYPES.AI_CHATBOT:
      return buildAiChatbotRoutingRules(options);
    default:
      return buildUnassignedRoutingRules(options);
  }
}
export function buildChannelRoutingRules(channelType, routingType, maybeOptions) {
  const distribution = getChannelRoutingDistribution(channelType);
  const options = setDistribution(distribution, maybeOptions || {});
  return buildRoutingRulesFromType(routingType, options);
}
export function buildRoutingRules(options) {
  const routingType = getType(options);
  return buildRoutingRulesFromType(routingType, options || undefined);
}
export const setFallback = (options = {}) => {
  const fallback = getIn(FALLBACK, options) || {};
  const inheritedOptions = pick(DISTRIBUTION, options);
  const fallbackOptions = merge(fallback, inheritedOptions);
  return set('fallback', buildRoutingRules(fallbackOptions), fromJS(options));
};